import { render } from "./404.vue?vue&type=template&id=bdde40de"
const script = {}
script.render = render

export default script